import { appColors } from '@backrs_ui/common-ui';

import { Box, SxProps, Theme } from '@mui/material';

type ProgressBarProps = Readonly<{
  currentQuestionSequence: number;
  totalLengthOfSurvey: number;
}>;

export const ProgressBar = ({ currentQuestionSequence, totalLengthOfSurvey }: ProgressBarProps) => {
  return (
    <Box sx={progressContainerStyle}>
      <Box
        width={(currentQuestionSequence / (totalLengthOfSurvey + 1)) * 100 + '%'}
        sx={filledProgressStyle}
      />
    </Box>
  );
};

const progressContainerStyle: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'row',
  width: '100%',
  backgroundColor: appColors.color.blue9,
} as const;

const filledProgressStyle: SxProps<Theme> = {
  borderTopRightRadius: 12,
  backgroundColor: appColors.color.blue1,
  height: '12px',
} as const;
